export default "__VITE_ASSET__HfqdopNU__ 400w, __VITE_ASSET__CIrrkxNF__ 800w, __VITE_ASSET__CHbs31gc__ 1024w";